import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IHnCompanyConfigItem } from '../../types/risk-manage/hn-company';

const hostUrl = getHostbaseUrl();

/**
 * 风控管理 - 海南公司配置列表
 */
export async function queryHnCompanyConfigList() {
  let data = [] as IHnCompanyConfigItem[];

  try {
    const { code, context, message } = await Http.get<IHnCompanyConfigItem[]>(
      `${hostUrl}/risk/hn-company-config/list`,
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 风控管理 - 保存海南公司配置
 */
export async function saveHnCompanyConfig(companyId: number) {
  try {
    const { code, message } = await Http.get(
      `${hostUrl}/risk/hn-company-config/add`,
      { companyId },
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 风控管理 - 删除海南公司配置
 * @param id 配置ID
 */
export async function deleteHnCompanyConfig(id: number) {
  try {
    const { code, message } = await Http.get(
      `${hostUrl}/risk/hn-company-config/delete`,
      { id },
    );

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

